export const salesOrderRoot = '/sales-orders'

export const salesOrdersRoute = {
  list: '/',
  create: '/create',
  view: '/:id',
  details: '/details',
}
